import React from 'react';
import {
    IconButton,
    Tooltip
} from 'material-ui';
import DeleteIcon from 'material-ui-icons/Delete';

const FaqTranslationsTableItemActionDelete = ({
    classes,
    handleClickOpen,
    faqTranslation,
    faqId
}) => {
    return (
        <span className={classes.tableIconBtn}>
            <Tooltip title="Delete Translation">
                <IconButton className="smallIconButton deleteColor" onClick={e => handleClickOpen(faqId, faqTranslation.id)}>
                    <DeleteIcon/>
                </IconButton>
            </Tooltip>
        </span>
    );
};

export default FaqTranslationsTableItemActionDelete;


// WEBPACK FOOTER //
// ./src/containers/faqs/translations/FaqTranslationsTableItemActionDelete.jsx